import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from 'src/app/services/data.service';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'app-kl-approval',
  templateUrl: './kl-approval.component.html',
  styleUrl: './kl-approval.component.scss'
})
export class KlApprovalComponent {
  preloader: boolean = true;
  searchSubject: Subject<string> = new Subject<string>();
  staticURL = GlobalConstants.staticFilesURL;
  selectedItem: any = {};
  handleSubmit(e: any) {
    e.preventDefault();
  }

  //filters
  searchFilterValue: string = '';
  logStatus : string = 'PENDING'
  dateFilter : any 

  libraryRequests : any 
  courseRequestHolder : any
  openAddKLModal : boolean = false

  constructor(
    public dataService: DataService,
    private orgUnitService: OrgUnitsService,
    private http: HttpClient,
    private permissionService: PermissionHandlerService,
    private ouService: OrgUnitsService,
    private domSenitizer: DomSanitizer
  ) { 

    this.searchSubject.pipe(
      debounceTime(300) // Adjust the debounce time as per your requirement (in milliseconds)
    ).subscribe((searchValue: string) => {
      this.getKlRequests(); // Function to make API call
    });
  }


  async ngOnInit() {
    this.getKlRequests()
    //  this.getData().then((f) => {
    //   this.getCategories().then((g) => {
    //     this.preloader = false;
    //     console.log(this.cat_items, this.ous, this.kLibrary);
    //   });
    // })
  }



  getQuery = () => {

    let query : any = {
      status : this.logStatus
    }

    let date = this.dateFilter ? this.generateMongoQuery(this.dateFilter) : null;
    date ? query.createdAt = date.date : null

    if (this.searchFilterValue !== null && this.searchFilterValue !== undefined && this.searchFilterValue !== "") {
      query['$text'] = { $search: this.searchFilterValue };
    }

    return query
  }

  getKlRequests = async () => {
    try {
      this.preloader = true
      let query = this.getQuery()
      const res = await this.dataService.postData('kl-log/get/?offset=1000&page=1',query);
      if (!res.error) {
        this.libraryRequests = res.data.data
      }
      this.preloader = false
    } catch (error) {
      //console.log(error)
    }
  };

  openCourseData(data : any){
    this.courseRequestHolder = data
    this.openAddKLModal = true

  }

  librarySubmit(event:any){
    this.openAddKLModal = false
    this.getKlRequests()
  }
  
  generateMongoQuery(dates: Date[]): any {
    const query: any = {};
    if (dates.length > 0) {
      query.date = { $gte: dates[0] };
      if (dates.length > 1) {
        if (dates[1]) {
          query.date.$lte = dates[1];
        } else {
          query.date.$lte = dates[0];
        }
      }
    } else {
      return null;
    }
  
    return query;
  }

  

  onInputChange(searchValue: any): void {
    this.searchSubject.next(searchValue.value);
  }

  refreshFilters(){
    this.searchFilterValue = ''
    this.dateFilter = undefined
    this.getKlRequests()
  }
  
}

